import CryptoJS from "crypto-js";

const SECRET_KEY = "LIST-IT-ADMIN"; // Secret key for encryption

// Encrypt Function
const encrypt = (msg) => {
  if (typeof msg !== "string") {
    msg = JSON.stringify(msg); // Convert objects to string
  }
  return CryptoJS.AES.encrypt(msg, SECRET_KEY).toString();
};

// Decrypt Function
const decrypt = (msg) => {
  try {
    const bytes = CryptoJS.AES.decrypt(msg, SECRET_KEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    
    return JSON.parse(decryptedText); // Convert back to JSON
  } catch (error) {
    console.error("Decryption failed:", error);
    return null; // Return null instead of empty string
  }
};

// Storage Utility
const localStorageServices = {
  setItem: (key, value) => {
    console.log(`set item ${key} --->>> ${value}`);
    const encryptedValue = encrypt(value);
    localStorage.setItem(key, encryptedValue);
  },

  getItem: (key) => {
    const encryptedValue = localStorage.getItem(key);
    if (!encryptedValue) {
      return null;
    }
    return decrypt(encryptedValue);
  },

  removeItem: (key) => {
    localStorage.removeItem(key);
  },

  clear: () => {
    localStorage.clear();
  }
};

export default localStorageServices;
